import React, { useState } from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../components/grid-container/GridContainer"
import UiTopInput from "../../components/form/UiTopInput"
import { UiButtonPrimary } from "../../components/form/UiButton"
import {
    UiContentWr,
    UiTopInputWr,
    UiTopInputHeading,
    UiContentCol,
    UiContentColWithSlider,
    UiColTitleWr,
    UiColTitle,
    UiViewAll,
    UiTabContentWr,
    UiTabContent
} from "../../components/common/UiPageElements"
import UiMainWrapper from "../../components/common/UiMainWrapper"
import TopHeader from "../../components/header/TopHeader"
import ShopSlider from "./Views/ShopSlider"
import UiBrowseAllRewards from "../../components/common/UiBrowseAllRewards"
import Footer from "../../components/footer/Footer"
import ShopMemberships from "./Views/ShopMemberships"
import { GoalCard } from '../Sidebar/GoalCard'
import { PointsCard } from '../Sidebar/PointsCard'
import { RecentPoints } from '../Sidebar/RecentPoints'
import { WishList } from '../Sidebar/WishList'
import { UiScrollNavWr, UiScrollNavItem } from "../../components/common/UiScrollToElements"
import HowShopWorks from "./Views/HowShopWorks"
import OurTopPicks from './OurTopPicks'
import TrendingAcrossSherbet from './Views/TrendingAcrossSherbet'
import MyFavourites from './Views/MyFavourites'


export default function ShopWrapper(props) {

    return (
        <>
            <UiMainWrapper>
                <TopHeader />
                <ShopSlider dots={false}
                    slidesToShow={2} />
                <UiContentWr>
                    <UiTabContentWr>
                        <UiRowContainer fluid="fluid">
                            <UiScrollNavWr>
                                <UiScrollNavItem hash="Lastest-campaigns" hashText="Recommended" />
                                <UiScrollNavItem hash="To-do-list" hashText="Trending" />
                                <UiScrollNavItem hash="" hashText="Memberships" />
                                <UiScrollNavItem hash="" hashText="Favourites" />
                                <UiScrollNavItem hash="" hashText="Wallet" />
                            </UiScrollNavWr>
                        </UiRowContainer>
                    </UiTabContentWr>
                </UiContentWr>

                <UiContentWr>
                    <UiRowContainer fluid="fluid" >
                        <UiCol lg="12" xl="12">
                            <UiContentCol>
                                <HowShopWorks />
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>


                <UiContentWr>
                    <UiRowContainer fluid="fluid" >
                        <UiCol lg="12" xl="9">
                            <UiContentCol>
                                <UiColTitleWr >
                                    <UiColTitle
                                        title="Our Top Picks"
                                        amount="10,442"
                                        subtitle="Carefully Selected Favourites" />
                                    <UiViewAll />
                                </UiColTitleWr>
                                <UiSingleRow className="mb-5">
                                    <OurTopPicks />
                                </UiSingleRow>

                                <UiColTitleWr id="Trending-vouchers">
                                    <UiColTitle
                                        title="Trending Across Sherbet"
                                        amount="7,404"
                                        subtitle="Trending Rewards" />
                                    <UiViewAll />
                                </UiColTitleWr>
                                <UiSingleRow>
                                    <TrendingAcrossSherbet />
                                </UiSingleRow>
                            </UiContentCol>
                        </UiCol>
                        <UiCol lg="6" xl="3" className="sb-sidebar-col">
                            <UiContentCol>
                                {/* <UiProfileCard /> */}
                                <RecentPoints />
                                <PointsCard />
                                <WishList />
                                <GoalCard />
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>

                <UiContentWr>
                    <UiRowContainer fluid="fluid" >
                        <UiCol lg="12" xl="12">
                            <UiContentColWithSlider>
                                <UiColTitleWr id="Lastest-campaigns">
                                    <UiColTitle
                                        title="My Favourites "
                                        amount="10,442"
                                        subtitle="Quick Find Favourites" />
                                    <UiViewAll className="sb-view-all-margin" />
                                </UiColTitleWr>

                                <MyFavourites />

                            </UiContentColWithSlider>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>

                <UiContentWr>
                    <UiRowContainer fluid="fluid" >
                        <UiCol lg="12" className="mt-4">
                            <UiContentCol>
                                <UiColTitleWr>
                                    <UiColTitle
                                        title="Buy: Memberships"
                                        subtitle="You deserve it, use it with Sherbet" />
                                    <UiViewAll className="sb-view-all-margin" />
                                </UiColTitleWr>
                                <UiSingleRow className="sb-mob-flex mt-4">
                                    <ShopMemberships />
                                </UiSingleRow>
                            </UiContentCol>
                        </UiCol>

                        <UiCol lg="12" className="mt-4">
                            <UiBrowseAllRewards />
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>
                <Footer />

            </UiMainWrapper>
        </>
    )
}



